<script setup>
import Helpers from '@/helpers/index.js';

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
    required: true
  },
  size: {
    type: Number,
    default: 35
  },
  textStyles: {
    type: String,
    default: 'font-size: 0.875rem; line-height: 2.188rem;'
  },
  textClass: {
    type: String,
    default: ''
  }
});
</script>

<template>
  <div v-if="props.user">
    <v-avatar :size="props.size" v-if="props.user?.avatar">
      <v-img contain :width="`${props.size}px`" :src="props.user.avatar" :alt="props.user?.username"></v-img>
    </v-avatar>
    <v-avatar v-else color="primary-blue" :size="props.size" class="tw-border tw-border-white">
      <!--      <span :style="`${props.textStyles}width: ${props.size}px; height: ${props.size}px;`">-->
      <span :class="props.textClass" :style="`${props.textStyles}`" :title="props.user?.username">
        {{ Helpers.getUserInitials(props.user) }}
      </span>
    </v-avatar>
  </div>
</template>

<style scoped></style>
